<jupiter-panel-container>
  <jupiter-panel-header
    header
    [panelDef]="panelDef"
    [editMode]="editMode | async"
    (startEditLayout)="onStartEditLayout()"
    (cancelEditLayout)="onCancelEditLayout()"
    (saveLayout)="onSaveLayout()"
  >
    <ng-container customActions>
      @if (touched | async) {
        <ts-button type="stroked" color="accent" class="mr-2" (click)="undoChanges();" [disabled]="isBusy | async"
          >Discard</ts-button
        >
        <ts-button [debounceTime]="500" (click)="saveChanges()" [disabled]="isBusy | async" [loading]="isBusy | async"
          >Save changes</ts-button
        >
      }
    </ng-container>
    <ng-container editModeCustomActions>
      @if (!(panelDef.meta.fields | tsMutateToAny: hasFields)) {
        <ts-button type="icon" color="basic" icon="add_circle" matTooltip="Add Row" (click)="manageField('first')">
        </ts-button>
      }
    </ng-container>
  </jupiter-panel-header>
  <ng-container body>
    @if (!(editMode | async)) {
      @for (fieldRow of panelDef.meta.fields; track $index) {
        <div class="body__row">
          @for (fieldName of fieldRow; track $index) {
            @if (lookupField(fieldName); as fieldDef) {
              <app-form-field
                #formFields
                [fieldDef]="fieldDef"
                [model]="model"
                (onUpdate)="update($event)"
                [data]="data"
                [readonly]="fieldDef.meta?.readonly"
              ></app-form-field>
            }
          }
        </div>
      }
    } @else {
      <div class="body__edit-fields" cdkDropListGroup>
        @for (fieldRow of panelDef.meta.fields; track rowIndex; let rowIndex = $index) {
          <div
            class="body__edit-fields__row"
            cdkDropList
            [cdkDropListData]="fieldRow"
            (cdkDropListDropped)="dropped($event)"
            cdkDropListOrientation="horizontal"
          >
            @for (fieldName of fieldRow; track colIndex; let colIndex = $index; let lastCol = $last) {
              <div class="body__edit-fields__row__col" cdkDrag>
                <ng-container dynamicFormRow elmType="select-field" [baseClassNames]="'flex flex-col'">
                  @if (lookupField(fieldName); as fieldDef) {
                    <ts-icon class="drag-handler" icon="drag_indicator" matTooltip="Drag me" cdkDragHandle> </ts-icon>
                    <select-field
                      [data]="{ fieldDefs }"
                      class="flex flex-col select-field"
                      [fieldDef]="fieldDef"
                      [model]="panelDef"
                      [rowIndex]="rowIndex"
                      [colIndex]="colIndex"
                    >
                    </select-field>
                  }
                  <div class="body__edit-fields__row__col__actions">
                    <ts-button
                      type="icon"
                      color="basic"
                      icon="cancel"
                      (click)="manageField('remove', { rowIndex, colIndex })"
                      matTooltip="Remove"
                    >
                    </ts-button>
                    @if (lastCol) {
                      <ts-button
                        type="icon"
                        color="basic"
                        icon="add_circle"
                        (click)="manageField('addInColumn', { rowIndex })"
                        matTooltip="Add"
                      >
                      </ts-button>
                      <ts-button
                        type="icon"
                        color="basic"
                        icon="library_add"
                        (click)="manageField('addInNewRow', { rowIndex, colIndex })"
                        matTooltip="Add"
                      >
                      </ts-button>
                    }
                  </div>
                </ng-container>
              </div>
            }
          </div>
        }
      </div>
    }
  </ng-container>
</jupiter-panel-container>
